export async function sha1Base64Url (text) {
    const digest = await crypto.subtle.digest('SHA-1', new TextEncoder().encode(text));
    const base64 = btoa(String.fromCharCode(...new Uint8Array(digest)));

    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
